module.exports = __webpack_public_path__ + "img/f5.9a19e1f5.png";